import { useState } from "react";
import axios from "axios.js";

// react-router-dom components
import { Link, useNavigate, useSearchParams } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";

// @mui icons

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
// import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "app/user/components/BasicLayout";

// Images
import bgImage from "assets/images/bg-sign-in-basic.jpeg";

import { useIsAuthenticated, useSignOut } from "react-auth-kit";
import { Formik } from "formik";
import * as Yup from "yup";
import { Snackbar, TextField, Alert, Backdrop, CircularProgress } from "@mui/material";
// import { LoadingButton } from "@mui/lab";
import usePageTitle from "app/pageTitle";

// inital login credentials
const initialValues = {
  password: "",
  cpassword: "",
};

// form field validation schema
const validationSchema = Yup.object().shape({
  password: Yup.string()
    .min(6, "Password must be atleast 6 character length")
    .required("Password is required!"),
  cpassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Password is required!"),
});

function ResetPwd() {
  const title = "Reset Password";
  usePageTitle(title);

  const navigate = useNavigate();
  const signOut = useSignOut();
  const isAuthenticated = useIsAuthenticated();
  if (isAuthenticated()) {
    // navigate("/dashboard");
    signOut();
  }

  const [searchParams] = useSearchParams();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("error");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const postData = async (params) => {
    const json = JSON.stringify(params);
    setShowLoading(true);
    await axios
      .post("agents/reset-password.json", json)
      .then((response) => {
        setShowLoading(false);
        if (response.data.status === "success") {
          setErrMsg("Password reset successfully. Please sign in.");
          setSeverity("success");
          setOpen(true);

          setTimeout(() => {
            navigate("/sign-in");
          }, 5000);
        } else {
          setSeverity("error");
          setErrMsg(response.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  };

  const handleFormSubmit = (values) => {
    const params = {
      password: values.password,
      reference: searchParams.get("ref"),
    };

    postData(params);
  };

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Showmax Portal
          </MDTypography>
          <MDTypography display="block" variant="button" color="white" my={1}>
            Reset password
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={showLoading}
            onClick={handleClose}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          <Snackbar
            open={open}
            autoHideDuration={6000}
            onClose={handleClose}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
              {errorMsg}
            </Alert>
          </Snackbar>
          <MDBox role="form">
            <Formik
              onSubmit={handleFormSubmit}
              initialValues={initialValues}
              validationSchema={validationSchema}
            >
              {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
                <form onSubmit={handleSubmit}>
                  <MDBox mb={2}>
                    {/* <MDInput type="password" label="Password" fullWidth /> */}
                    <TextField
                      fullWidth
                      size="small"
                      name="password"
                      type="password"
                      label="New Password"
                      variant="outlined"
                      onBlur={handleBlur}
                      value={values.password}
                      onChange={handleChange}
                      helperText={touched.password && errors.password}
                      error={Boolean(errors.password && touched.password)}
                      sx={{ mb: 1.5 }}
                    />
                  </MDBox>
                  <MDBox mb={2}>
                    {/* <MDInput type="password" label="Password" fullWidth /> */}
                    <TextField
                      fullWidth
                      size="small"
                      name="cpassword"
                      type="password"
                      label="Repeat Password"
                      variant="outlined"
                      onBlur={handleBlur}
                      value={values.cpassword}
                      onChange={handleChange}
                      helperText={touched.cpassword && errors.cpassword}
                      error={Boolean(errors.cpassword && touched.cpassword)}
                      sx={{ mb: 1.5 }}
                    />
                  </MDBox>
                  <MDBox mt={4} mb={1}>
                    <MDButton variant="gradient" color="info" type="submit" fullWidth>
                      Change Password
                    </MDButton>
                  </MDBox>
                  <MDBox mt={3} mb={1} textAlign="center">
                    <MDTypography variant="button" color="text">
                      Already have an account?{" "}
                      <MDTypography
                        component={Link}
                        to="/sign-in"
                        variant="button"
                        color="info"
                        fontWeight="medium"
                        textGradient
                      >
                        Sign In
                      </MDTypography>
                    </MDTypography>
                  </MDBox>
                </form>
              )}
            </Formik>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default ResetPwd;
